export default function PlanUpgradeCard({
  title = "Upgrade to Premium",
  message = "Unlock more audits and premium reports.",
  ctaLabel = "Upgrade Now",
  ctaHref = "/settings?tab=workspace",
}) {
  return (
    <div className="card" style={{ marginBottom: 20, background: "#eef2ff", border: "1px solid #c7d2fe" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}>
        <div>
          <h3 style={{ margin: 0, color: "#3730a3", fontSize: "1.1rem" }}>{title}</h3>
          <p style={{ margin: "4px 0 0", color: "#4338ca", fontSize: "0.9rem" }}>{message}</p>
        </div>
        <a href={ctaHref} className="btn btn-primary">{ctaLabel}</a>
      </div>
    </div>
  );
}

export function PlanUpgradeModal({
  title = "Upgrade to Premium",
  message = "Unlock more audits and premium reports.",
  ctaLabel = "Upgrade Now",
  ctaHref = "/settings?tab=workspace",
  onClose,
}) {
  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(15, 23, 42, 0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1200,
      padding: 20,
    }}>
      <div style={{
        width: "min(700px, 100%)",
        background: "#ffffff",
        borderRadius: 20,
        overflow: "hidden",
        boxShadow: "0 40px 120px rgba(15, 23, 42, 0.18)",
      }}>
        <div style={{ display: "flex", justifyContent: "flex-end", padding: 16 }}>
          <button
            type="button"
            onClick={onClose}
            className="btn btn-ghost"
            style={{ padding: "8px 12px" }}
          >
            Close
          </button>
        </div>
        <div style={{ padding: "0 24px 24px" }}>
          <PlanUpgradeCard
            title={title}
            message={message}
            ctaLabel={ctaLabel}
            ctaHref={ctaHref}
          />
        </div>
      </div>
    </div>
  );
}
